import { render, staticRenderFns } from "./SupportMenu.vue?vue&type=template&id=61d08777&scoped=true&"
import script from "./SupportMenu.vue?vue&type=script&lang=ts&"
export * from "./SupportMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SupportMenu.vue?vue&type=style&index=0&id=61d08777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d08777",
  null
  
)

export default component.exports